import { HStack, VStack } from 'ui_2';
import puzzleIconBlack from '../../../public/assets/logo_black.png';
import { Socials } from '../Socials';
import { useDappState } from '@src/hooks/useDappState';

export const QuestDappFooter = () => {
  const { isPuzzleWalletWebview } = useDappState();

  if (isPuzzleWalletWebview === false) {
    return (
      <VStack className='mt-auto w-full items-center gap-4'>
        <HStack className='w-full items-center gap-2'>
          <a
            href='https://app.puzzle.online'
            target='_blank'
            className='inline-block'
          >
            <img
              src={puzzleIconBlack}
              className='h-[50px]'
              alt='Puzzle Wallet Logo'
            />
          </a>
          <HStack className='flex-grow' />
          <Socials />
        </HStack>
      </VStack>
    );
  }

  return null;
};
